import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import Categories from "./pages/Categories/Categories";

export const customPages = [
	{ moduleId: "d4fcadd7-888d-4bd2-863a-a64f448a281a", path: "list", content: <Categories /> },
] as CustomPage[];
